// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"af214b03","725":"3f1566ce"}[chunkId] + ".chunk.js";
};